<template>
    <div class="main-page-tabs-container d-flex align-center justify-center">
        <client-only>
            <hotel-search-form is-iframe :city-id="cityId" />
        </client-only>
    </div>
</template>

<script lang="ts">
    import {Component, Vue} from 'vue-facing-decorator'
    import HotelSearchForm from '~src/components/search/forms/hotelSearchForm.src'

    @Component({
        components: {
            HotelSearchForm,
        },
        async setup() {
            await useAsyncData('hotel-search-form', async () => {
                await SearchFormPage.__vccOpts.methods.fetch()
                return true
            })
        },
    })
    export class SearchFormPage extends Vue {
        scrollHeight = 0
        intervalId

        async fetch() {
            await cmsStore.loadPopularDestinations()
        }

        async mounted() {
            this.intervalId = setInterval(() => {
                if (document.documentElement.scrollHeight !== this.scrollHeight) {
                    this.scrollHeight = document.documentElement.scrollHeight
                    window.parent.postMessage({height: this.scrollHeight}, '*')
                }
            }, 300)
        }

        beforeUnmount() {
            clearInterval(this.intervalId)
        }

        get cityId() {
            return this.$route.query.cityId
        }
    }

    export default SearchFormPage
</script>
